/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    let links = project.getNodeLinks(feature, 'timestamp_now');
    const FORMAT = feature.getSettingValue('FORMAT');

    let code = '';
    if (links.length > 0) {
        const link = links[0];
        code += `#****${link.getSourceId()}****#`;
    }

    links = project.getNodeLinks(feature, 'timestamp_get');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
time_now=datetime_current_timestamp()
${code}`,
        });
        //         if (FORMAT === 'datetime') {
        //             blocks.push({
        //                 location: link.getSourceId(),
        //                 blockType: BlockType.CODE,
        //                 id: link.getID(),
        //                 template: `
        // dim time_now as dword = datetime_current_timestamp()
        // ${code}`,
        //             });
        //         } else if (FORMAT === 'time') {
        //             blocks.push({
        //                 location: link.getSourceId(),
        //                 blockType: BlockType.CODE,
        //                 id: link.getID(),
        //                 template: `
        // dim time_now as dword = datetime_current_timestamp()
        // dim tmp_minutes as word=0
        // td_get_tzone_offset(APP_TIMEZONE, tmp_minutes)
        // time_now=time_now-(tmp_minutes*60)
        // ${code}`,
        //             });
        //         }
    }

    return blocks;
};
